import React from "react";
import {dialogAction} from "../../store/actions/dialogAction";
import Title from "../../components/title/title";
import styles from "../../static/css/pages.module.css";
import RegisterClientForm from "./form";
import ButtonCancel from "../../components/form/button/button_cancel";
import Button from "../../components/form/button/button";
import Icon from "../../components/icons/icons";
import Input from "../../components/form/input/input";
import InputMail from "../../components/form/input/input_mail";
import Modal from "../../components/modal/modal";
import {connect} from "react-redux";
import * as consts from "../../store/constants/dialog";
import ieSvg from "../../components/icons/ieSvg";
import Dropdown from "../../components/form/dropdown/dropdown";

class ClientsList extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      modal: '',
      editInn: '',
      registerForm: '',
      clientType: ''
    };
    this.clientTypesForEdit = [
      {value: 'PHYSICAL', label: 'физическое лицо'},
      {value: 'INDIVIDUAL', label: 'индивидуальный предприниматель'},
    ];
  }

  componentDidMount() {
    ieSvg();
  }

  handleFormShow = () => {
    this.setState({
      registerForm: 'visible',
    })
  }
  handleFormHide = () => {
    this.setState({
      registerForm: '',
    })
  }

  handleUpdate = (e) => {
    let form = e.currentTarget.closest("[data-form]");
    let req = form.querySelectorAll("[data-required][value='']");
    let parent;
    let formData;
    formData = {};
    parent = e.target.closest("[data-client]");
    let parentInn = parent.getAttribute("data-inn");
    let clientType = parent.getAttribute("data-client-type");
    if (req.length) {
      req.forEach(input => {
        let event = new Event('input', {
          bubbles: true
        });
        input.dispatchEvent(event)
      });
      return false;
    }
    parent.querySelectorAll("input").forEach(function(el){
      let name = el.getAttribute("name");
      let value = el.getAttribute("value");
      if (!name) return;
      if (name === 'newType' && value=== clientType) return;
      formData[name] = value;
    });
    formData['oldInn'] = parentInn;
    let typeRequest = this.getNameRequestByClientType(this.state.clientType);
    this.props.fetchData(process.env.REACT_APP_GATE + typeRequest + "/edit", consts.DIALOG, formData);
  }
  handleEdit = (e) => {
    let parent;
    let clientType;
    parent = e.target.closest("[data-client]");
    clientType = parent.getAttribute('data-client-type');
    parent.querySelector("[data-edit]").style.display = 'block';
    this.setState({
      clientType: clientType
    });
  }
  handleCancel = (e) => {
    let parent;
    parent = e.target.closest("[data-edit]");
    parent.style.display = 'none';
  }

  handleDialogDelete = (e) => {
    let parent;
    let clientInn;
    let clientType
    parent = e.target.closest("[data-client]");
    clientType = parent.getAttribute('data-client-type');
    clientInn = parent.getAttribute("data-inn");
    this.setState({
      editInn: clientInn,
      modal: 'DELETE',
      clientType: clientType
    })
  }
  handleReload = () => {
    this.props.fetchData('', consts.DIALOG, null);
    this.props.onReload();
  };
  handleDelete = (e) => {
    let formData;
    formData = { inn: this.state.editInn }
    let typeRequest = this.getNameRequestByClientType(this.state.clientType);
    this.props.fetchData(process.env.REACT_APP_GATE + typeRequest + "/delete", consts.DIALOG, formData);
  }
  handleClose = () => {
    this.setState({modal: ''})
    this.props.fetchData('', consts.DIALOG, null);
  };

  getNameRequestByClientType = type => {
    switch (type) {
      case 'PHYSICAL': return 'physical';
      case 'INDIVIDUAL': return 'individual';
      default: return 'jurperson';
    }
  }

  renderDialog(params) {
    switch(params) {
      case "SUCCESS":
        return <Modal
          class="dialog-success l-align_center"
          modalIcon="icon_success"
          viewbox="0 0 80 80"
          handleClick={this.handleReload.bind(this)}
          title="Изменения внесены"
          body={<div className={styles.article}>Данные успешно отредактированы<div className={styles.article}> </div>
          </div>}
          footer="l-align_right"
          link={this.handleReload.bind(this)}
          button="Закрыть"
        />
      case "ERROR":
        return <Modal
          class="dialog-success l-align_center"
          modalIcon="icon_error"
          viewbox="0 0 80 80"
          handleClick={this.handleClose.bind(this)}
          title="Изменения не внесены"
          body={<div className={styles.article}>{this.props.data.items.data.result.errorMessage}<div className={styles.article}> </div>
          </div>}
          footer="l-align_right"
          link={this.handleClose.bind(this)}
          button="Закрыть"
        />
      default:
        return null
    }
  }

  render() {
    return (
      <div className={styles.content}>
        <div className="l-grid_pt-8 mobile_l-grid">
          <div className="l-grid__item_1"> </div>
          <div className="l-grid__item_6 mobile_l-grid__item_10 l-position_relative">
            <Title icon="icon_menu-clients" title="Мои клиенты"/>
            {this.state.registerForm ?
              <div id="register-client-form" className="l-position_relative">
                <div className={styles.article}>
                  С момента добавления клиента, поступления от него будут автоматически фиксироваться как ваш доход.
                </div>
                <RegisterClientForm />
                <div className="button_wrap">
                  <ButtonCancel title="Свернуть" onClick={this.handleFormHide} id="form-hide" />
                </div>
              </div>
              :
              <div className="title_button">
                <Button title="Добавить клиента"  onClick={this.handleFormShow}/>
              </div>
            }
            <div className={styles.clients_list}>
              {this.props.items.contragents.sort((b, a) => Date.parse(a.startDate) - Date.parse(b.startDate)).map((d, i) =>
                <div key={i} data-client data-inn={d.inn} data-client-type={d.type}>
                  <div className={styles.clients_item}>
                    <div className="l-grid_pt-8">
                      <div className="l-grid__item_1">
                        <span className={styles.history_icon}>
                          <Icon name="icon_history_clients" viewbox="0 0 32 32" />
                        </span>
                      </div>
                      <div className="l-grid__item_5 l-grid_align-middle">
                        <div className={styles.history_client}>
                          <div className="text-ellipsed">
                            {d.name}
                          </div>
                        </div>
                        <div className={styles.text_gray}>
                          {d.inn}
                        </div>
                        <div className={styles.text_gray}>
                          <div className="text-ellipsed">
                            {d.serviceName}
                          </div>
                        </div>
                      </div>
                      <div className="l-grid__item_2 l-align_right" data-actions>
                        <div className={styles.history_icon_actions}>
                          <span className={styles.link_with_icon} title="Редактировать" onClick={this.handleEdit}>
                            <Icon name="icon_edit" viewbox="0 0 24 24" />
                          </span>
                          <span className={styles.link_with_icon} title="Удалить" onClick={this.handleDialogDelete}>
                            <Icon name="icon_trash" viewbox="0 0 24 24" />
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className={`${styles.item_details} ${styles.item_details_client}`} data-edit data-form>
                    <div className="l-grid_pt-8 mobile_l-grid">
                      <div className="l-grid__item_1"></div>
                      {d.type !== 'JURIDICAL' ?
                          <div className="l-grid__item_3 mobile_l-grid__item_10">
                            <Dropdown label="Группа клиента" name="newType"
                                      defaultValue={this.clientTypesForEdit.find(item => item.value === d.type)}
                                      placeholder="" required items={this.clientTypesForEdit}
                            />
                          </div> : null }
                      <div className="l-grid__item_3 mobile_l-grid__item_10">
                        <Input label="ИНН клиента" required length="10|12" maxlength="12" value={d.inn} name="inn" dataNumber />
                      </div>
                    </div>
                    <div className="l-grid_pt-8 mobile_l-grid">
                      <div className="l-grid__item_1"></div>
                      <div className="l-grid__item_6 mobile_l-grid__item_10">
                        <Input label="Наименование клиента" maxlength="160" name="name" value={d.name} />
                        <Input label="Услуга" maxlength="256" required name="serviceName" value={d.serviceName} />
                        <InputMail label="Е-mail клиента" name="email" maxlength="100" value={d.email} required />
                        <div className="l-float_right"></div>
                      </div>
                    </div>
                    <div className="l-grid_pt-8 mobile_l-grid">
                      <div className="l-grid__item_1"></div>
                      <div className="l-grid__item_2 mobile_l-grid__item_3 phone_display_none">
                        <div className={styles.inline_button_link}>
                          <span onClick={this.handleDialogDelete} className={styles.link_with_icon} title="Удалить">
                            <Icon name="icon_trash" viewbox="0 0 24 24" />
                            <span>Удалить</span>
                          </span>
                        </div>
                      </div>
                      <div className="l-grid__item_4 mobile_l-grid__item_7 l-align_right phone_l-grid__item_10">
                        <Button title="Отменить" datacancel onClick={this.handleCancel}/>
                        <Button title="Подтвердить" dataAttr={d.inn} onClick={this.handleUpdate}/>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
            <span id="reload-clients" onClick={this.handleReload}></span>
          </div>
        </div>
        {this.state.modal === 'DELETE' ?
          <Modal
            class="dialog-success l-align_center"
            modalIcon="icon_question"
            viewbox="0 0 80 80"
            handleClick={this.handleClose.bind(this)}
            title="Удалить клиента?"
            body={<div className={styles.article}>
              Подтвердите удаление.
              <div className={styles.article}> </div>
            </div>}
            footer="l-align_right"
            cancelLink={this.handleClose.bind(this)}
            cancelButton="Отменить"
            link={this.handleDelete.bind(this)}
            button="Подтвердить"
          />
          :
          null
        }
        {this.props.dialog.items ?
          this.renderDialog(this.props.dialog.items.data.result.status)
          :
          null
        }
      </div>
    )
  }
}

const mapStateToProps = state => ({dialog: state.updateDialog})

const mapDispatchToProps = dispatch => {
  return {fetchData: (url, types, body) => dispatch(dialogAction(url, types, body))}
}

export default connect(mapStateToProps, mapDispatchToProps)(ClientsList);
